import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ProductCardProps } from '.';
import { getRemainingCount } from '@/utils/common/product-card';

export default function RemainCount(props: Partial<ProductCardProps>) {
  const { data, isHorizontal = false } = props;
  const { t } = useTranslation('common');

  const remainCount = getRemainingCount(data);

  return remainCount ? (
    <div data-testid="wid-product-card-remain-count" className="w-full mb-[2px]">
      <span className="enki-body-3xs-strong text-pricing-txt inline-block">
        {isHorizontal ? t('remain_count', { remainCount: remainCount }) : t('order_soon', { quantity: remainCount })}
      </span>
    </div>
  ) : null;
}
